/* =====================================================================
   BLANK2U — interacciones (header, quick add, pestañas, carrusel, popup)
   Archivo: assets/b2u.js
   ===================================================================== */
(() => {
  if (window.__b2uLoaded) return;
  window.__b2uLoaded = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const def = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };

  async function refreshCart() {
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      document.querySelectorAll('[data-b2u-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('b2u:cart-updated', { detail: cart }));
      return cart;
    } catch (e) { return null; }
  }
  window.B2U = { refreshCart };

  /* ---------- HEADER ---------- */
  class B2UHeader extends HTMLElement {
    connectedCallback() {
      this.menuBtn = this.querySelector('[data-menu-toggle]');
      this.drawer = this.querySelector('[data-drawer]');
      this.search = this.querySelector('[data-search]');
      this.menuBtn && this.menuBtn.addEventListener('click', () => this.toggle('menu'));
      this.querySelectorAll('[data-search-toggle]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.toggle('search'); }));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('click', e => { if (this.classList.contains('is-open') && !this.contains(e.target)) this.close(); });

      document.addEventListener('shopify:section:load', () => refreshCart());
    }
    toggle(which) {
      const panel = which === 'menu' ? this.drawer : this.search;
      if (!panel) return;
      const willOpen = panel.hidden;
      this.close();
      if (!willOpen) return;
      panel.hidden = false;
      this.classList.add('is-open');
      if (which === 'menu') {
        this.menuBtn && this.menuBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('b2u-lock');
      } else {
        const input = panel.querySelector('input');
        input && setTimeout(() => input.focus(), 60);
      }
    }
    close() {
      [this.drawer, this.search].forEach(p => { if (p) p.hidden = true; });
      this.classList.remove('is-open');
      this.menuBtn && this.menuBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('b2u-lock');
    }
  }
  def('b2u-header', B2UHeader);

  /* ---------- TARJETA + QUICK ADD ---------- */
  class B2UCard extends HTMLElement {
    connectedCallback() {
      const plus = this.querySelector('[data-qa-open]');
      plus && plus.addEventListener('click', e => {
        e.preventDefault();
        if (this.dataset.single) this.add(this.dataset.single, plus);
        else this.classList.toggle('qa-open');
      });
      this.querySelectorAll('[data-variant]').forEach(btn => btn.addEventListener('click', e => {
        e.preventDefault();
        this.add(btn.dataset.variant, btn);
      }));
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.classList.remove('qa-open'); });
    }
    async add(id, btn) {
      btn.classList.add('is-loading');
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add');
        if (this.dataset.redirect === 'true') { window.location.href = root + 'cart'; return; }
        const drawer = document.querySelector('b2u-cart-drawer');
        if (drawer) await drawer.refresh(true);
        else { this.flash(this.dataset.addedText || 'Añadido'); await refreshCart(); }
      } catch (e) {
        this.flash(this.dataset.errorText || 'Sin stock');
      }
      btn.classList.remove('is-loading');
      this.classList.remove('qa-open');
    }
    flash(text) {
      const f = this.querySelector('.b2u-card__flash');
      if (!f) return;
      f.textContent = text;
      f.classList.add('is-on');
      clearTimeout(this._t);
      this._t = setTimeout(() => f.classList.remove('is-on'), 1600);
    }
  }
  def('b2u-card', B2UCard);

  /* ---------- PESTAÑAS DE COLECCIÓN ---------- */
  class B2UTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.links = [...this.querySelectorAll('[data-tab-link]')];
      this.tabs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
      document.addEventListener('shopify:block:select', e => {
        const i = this.tabs.findIndex(t => t.dataset.blockId === e.detail.blockId);
        if (i > -1) this.show(i);
      });
    }
    show(i) {
      this.tabs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-selected', String(i === j)); });
      this.panels.forEach((p, j) => { p.hidden = i !== j; });
      this.links.forEach((l, j) => { l.hidden = i !== j; });
    }
  }
  def('b2u-tabs', B2UTabs);

  /* ---------- CARRUSEL ---------- */
  class B2UCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      if (!track) return;
      this.querySelectorAll('[data-dir]').forEach(b => b.addEventListener('click', () => {
        track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
      }));
      let down = false, moved = false, x0 = 0, s0 = 0;
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
      });
      track.addEventListener('pointermove', e => {
        if (!down) return;
        const dx = e.clientX - x0;
        if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        if (moved) track.scrollLeft = s0 - dx;
      });
      track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', e => e.preventDefault());
    }
  }
  def('b2u-carousel', B2UCarousel);

  /* ---------- POPUP NEWSLETTER ---------- */
  class B2UPopup extends HTMLElement {
    connectedCallback() {
      const key = 'b2u-pop-' + (this.dataset.key || '1');
      const submittedFlag = 'b2u-pop-submitted';
      let seen = null, submitted = null;
      try { seen = localStorage.getItem(key); submitted = sessionStorage.getItem(submittedFlag); } catch (e) {}

      const form = this.closest('form');
      form && form.addEventListener('submit', () => { try { sessionStorage.setItem(submittedFlag, '1'); } catch (e) {} });

      this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.close(key); }));
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(key); });

      document.addEventListener('shopify:section:select', e => { if (e.detail.sectionId === this.dataset.section) this.open(); });
      document.addEventListener('shopify:section:deselect', e => { if (e.detail.sectionId === this.dataset.section) this.close(); });
      if (this.dataset.designMode === 'true') return;

      if (submitted && (this.dataset.result === 'success' || this.dataset.result === 'error')) {
        try { sessionStorage.removeItem(submittedFlag); } catch (e) {}
        this.open();
        if (this.dataset.result === 'success') { try { localStorage.setItem(key, '1'); } catch (e) {} }
        return;
      }
      if (!seen) setTimeout(() => this.open(), Number(this.dataset.delay || 5) * 1000);
    }
    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      const c = this.querySelector('.b2u-pop__close');
      c && setTimeout(() => c.focus({ preventScroll: true }), 50);
    }
    close(key) {
      this.classList.remove('is-open');
      setTimeout(() => { this.hidden = true; }, 300);
      if (key) { try { localStorage.setItem(key, '1'); } catch (e) {} }
    }
  }
  def('b2u-popup', B2UPopup);

  /* ---------- CART DRAWER ---------- */
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const imgUrl = (url, w) => {
    if (!url) return '';
    try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  };

  class B2UCartDrawer extends HTMLElement {
    connectedCallback() {
      /* Mover al <body> para quedar por encima del header y de cualquier sección */
      if (this.parentElement !== document.body) {
        document.querySelectorAll('body > b2u-cart-drawer').forEach(d => { if (d !== this) d.remove(); });
        document.body.appendChild(this);
        return;
      }
      if (this._init) return;
      this._init = true;
      this.inner = this.querySelector('[data-cart-items]');
      this.foot = this.querySelector('[data-cart-foot]');
      this.empty = this.querySelector('[data-cart-empty]');
      this.countEl = this.querySelector('[data-cart-title-count]');
      this.titleEl = this.querySelector('[data-cart-title]');
      this.subtotalEl = this.querySelector('[data-cart-subtotal]');
      this.discountsEl = this.querySelector('[data-cart-discounts]');
      this.shipEl = this.querySelector('[data-cart-ship]');
      this.giftEl = this.querySelector('[data-cart-gift]');
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.t = {
        giftText: this.dataset.tGiftText || 'Agregaste [n] kit · Reclama tus piezas gratis',
        title: this.dataset.tTitle || 'Tu carrito',
        empty: this.dataset.tEmpty || 'Tu carrito está vacío.',
        remove: this.dataset.tRemove || 'Eliminar',
        shipGo: this.dataset.tShipGo || 'Te faltan [amount] para el envío gratis',
        shipOk: this.dataset.tShipOk || '¡Tienes envío gratis!'
      };
      this.threshold = Number(this.dataset.freeShipping || 0) * 100;

      this.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.close(); }));
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });

      document.addEventListener('click', e => {
        const opener = e.target.closest('[data-b2u-cart-open], a[href$="/cart"]:not([data-no-drawer])');
        if (!opener || this.contains(opener) || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        this.refresh(true);
      });

      this.addEventListener('change', e => {
        const t = e.target.closest('[data-ins-toggle]');
        if (t) this.toggleInsurance(t);
      });

      this.addEventListener('click', e => {
        const q = e.target.closest('[data-qty]');
        if (q) { e.preventDefault(); this.change(q.dataset.key, Number(q.dataset.qty)); return; }
        const club = e.target.closest('[data-club-open]');
        if (club) {
          e.preventDefault();
          const f = club.closest('.b2u-cd__promo').querySelector('.b2u-cd__club');
          const open = f.hidden;
          f.hidden = !open;
          club.setAttribute('aria-expanded', String(open));
          if (open) f.querySelector('input[type="email"]').focus();
          return;
        }
        const up = e.target.closest('[data-upsell-add]');
        if (up) { e.preventDefault(); this.add(up.dataset.upsellAdd, up); }
      });

      /* Formularios de producto (Dawn) → cajón en vez de /cart */
      if (this.dataset.interceptForms === 'true') {
        document.addEventListener('submit', e => {
          const form = e.target;
          if (!(form instanceof HTMLFormElement)) return;
          const action = form.getAttribute('action') || '';
          if (!/\/cart\/add(\.js)?$/.test(action.split('?')[0])) return;
          if (e.submitter && e.submitter.name === 'checkout') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addForm(form, e.submitter);
        }, true);
      }

      const initial = this.querySelector('[data-cart-json]');
      if (initial) { try { this.render(JSON.parse(initial.textContent)); } catch (err) {} }
      document.addEventListener('shopify:section:select', e => { if (e.detail.sectionId === this.dataset.section) this.refresh(true); });
      document.addEventListener('shopify:section:deselect', e => { if (e.detail.sectionId === this.dataset.section) this.close(); });
    }

    open() {
      this.hidden = false;
      document.documentElement.classList.add('b2u-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      const panel = this.querySelector('.b2u-cd__panel');
      panel && setTimeout(() => panel.focus({ preventScroll: true }), 80);
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('b2u-lock');
      clearTimeout(this._ht);
      this._ht = setTimeout(() => { if (!this.classList.contains('is-open')) this.hidden = true; }, 700);
    }

    async refresh(openAfter) {
      const cart = await refreshCart();
      if (cart) this.render(cart);
      if (openAfter) this.open();
    }

    async add(id, btn) {
      btn && btn.classList.add('is-loading');
      try {
        const r = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        if (!r.ok) throw await r.json();
        await this.refresh(true);
      } catch (err) { this.error(err && err.description); }
      btn && btn.classList.remove('is-loading');
    }

    async addForm(form, submitter) {
      const btn = submitter || form.querySelector('[type="submit"]');
      btn && btn.classList.add('is-loading');
      btn && btn.setAttribute('aria-disabled', 'true');
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await r.json();
        if (!r.ok) throw data;
        await this.refresh(true);
      } catch (err) {
        const msg = (err && (err.description || err.message)) || 'Error';
        const wrap = form.closest('product-form');
        const box = wrap && wrap.querySelector('.product-form__error-message');
        if (box) { box.textContent = msg; box.closest('.product-form__error-message-wrapper')?.removeAttribute('hidden'); }
        else this.error(msg, true);
      }
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-disabled');
    }

    async change(key, quantity) {
      const row = this.querySelector(`[data-line="${CSS.escape(key)}"]`);
      row && row.classList.add('is-loading');
      try {
        const r = await fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await r.json();
        if (!r.ok) throw cart;
        this.render(cart);
        document.querySelectorAll('[data-b2u-cart-count]').forEach(el => { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('b2u:cart-updated', { detail: cart }));
      } catch (err) {
        row && row.classList.remove('is-loading');
        this.error(err && err.description);
      }
    }

    async toggleInsurance(box) {
      const id = Number(box.dataset.variant);
      const post = (url, body) => fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      box.disabled = true;
      try {
        let r = null;
        if (box.checked) {
          r = await post('cart/add.js', { items: [{ id, quantity: 1 }] });
        } else {
          const before = await refreshCart();
          const line = before && before.items.find(i => i.variant_id === id);
          if (line) r = await post('cart/change.js', { id: line.key, quantity: 0 });
        }
        if (r && !r.ok) throw await r.json();
        const cart = await refreshCart();
        if (cart) {
          this.render(cart);
          document.querySelectorAll('[data-b2u-cart-count]').forEach(el => { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('b2u:cart-updated', { detail: cart }));
        }
      } catch (err) {
        box.checked = !box.checked;
        this.error(err && err.description);
      } finally {
        box.disabled = false;
      }
    }

    error(msg, openAfter) {
      const box = this.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = msg || 'No se pudo actualizar el carrito.';
      box.hidden = false;
      clearTimeout(this._et);
      this._et = setTimeout(() => { box.hidden = true; }, 4000);
      if (openAfter) this.open();
    }

    money(cents) {
      const fmt = this.moneyFormat;
      const n = Number(cents || 0) / 100;
      const group = (num, dec, ts, ds) => {
        const [i, d] = num.toFixed(dec).split('.');
        return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (d ? ds + d : '');
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        switch (k) {
          case 'amount_no_decimals': return group(n, 0, ',', '.');
          case 'amount_with_comma_separator': return group(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
          case 'amount_with_space_separator': return group(n, 2, ' ', ',');
          default: return group(n, 2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }

    render(cart) {
      const has = cart.item_count > 0;
      if (this.countEl) this.countEl.textContent = cart.item_count;
      if (this.titleEl) this.titleEl.textContent = has ? this.t.title : this.t.empty;
      this.classList.toggle('is-empty', !has);
      if (this.empty) this.empty.hidden = has;
      if (this.foot) this.foot.hidden = !has;

      const ins = this.querySelector('[data-ins-toggle]');
      const insId = ins ? String(ins.dataset.variant) : null;
      if (ins && !ins.disabled) ins.checked = cart.items.some(i => String(i.variant_id) === insId);

      if (this.inner) {
        this.inner.innerHTML = cart.items.filter(item => String(item.variant_id) !== insId).map(item => {
          const img = item.image ? `<img src="${esc(imgUrl(item.image, 360))}" alt="${esc(item.product_title)}" width="180" height="227" loading="lazy">` : '';
          const opts = (item.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => `<p>${esc(o.name)}: ${esc(o.value)}</p>`).join('');
          const props = Object.entries(item.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_').map(([k, v]) => `<p>${esc(k)}: ${esc(v)}</p>`).join('');
          const plan = item.selling_plan_allocation ? `<p>${esc(item.selling_plan_allocation.selling_plan.name)}</p>` : '';
          const strike = item.original_line_price > item.final_line_price ? `<s>${this.money(item.original_line_price)}</s>` : '';
          const discs = (item.line_level_discount_allocations || []).map(d => `<p class="b2u-cd__disc">${esc(d.discount_application.title)} (−${this.money(d.amount)})</p>`).join('');
          const key = esc(item.key);
          return `
            <div class="b2u-cd__item" data-line="${key}">
              <a href="${esc(item.url)}" class="b2u-cd__img">${img}</a>
              <div class="b2u-cd__info">
                <div class="b2u-cd__row">
                  <a href="${esc(item.url)}" class="b2u-cd__name">${esc(item.product_title)}</a>
                  <p class="b2u-cd__price">${strike}<span>${this.money(item.final_line_price)}</span></p>
                </div>
                <div class="b2u-cd__meta">${opts}${props}${plan}${discs}</div>
                <div class="b2u-cd__actions">
                  <div class="b2u-cd__qty">
                    <button type="button" data-qty="${item.quantity - 1}" data-key="${key}" aria-label="−1">
                      <svg viewBox="0 0 10 10" width="10" height="10"><path d="M1 5h8" stroke="currentColor"/></svg>
                    </button>
                    <span>${item.quantity}</span>
                    <button type="button" data-qty="${item.quantity + 1}" data-key="${key}" aria-label="+1">
                      <svg viewBox="0 0 10 10" width="10" height="10"><path d="M1 5h8M5 1v8" stroke="currentColor"/></svg>
                    </button>
                  </div>
                  <button type="button" class="b2u-cd__remove" data-qty="0" data-key="${key}">${esc(this.t.remove)}</button>
                </div>
              </div>
            </div>`;
        }).join('');
      }

      if (this.subtotalEl) this.subtotalEl.textContent = this.money(cart.total_price);
      if (this.discountsEl) {
        const list = cart.cart_level_discount_applications || [];
        this.discountsEl.innerHTML = list.map(d => `<div class="b2u-cd__line"><span>${esc(d.title)}</span><span>−${this.money(d.total_allocated_amount)}</span></div>`).join('');
      }
      if (this.shipEl && this.threshold > 0) {
        const left = this.threshold - cart.total_price;
        const pct = Math.min(100, Math.round(cart.total_price / this.threshold * 100));
        this.shipEl.querySelector('[data-ship-text]').textContent = left > 0 ? this.t.shipGo.replace('[amount]', this.money(left)) : this.t.shipOk;
        this.shipEl.querySelector('[data-ship-bar]').style.width = pct + '%';
        this.shipEl.hidden = !has;
      }
      if (this.giftEl) {
        const kits = (cart.items || []).reduce((a, it) => a + (String(it.handle || '').indexOf('kit-marca') === 0 ? it.quantity : 0), 0);
        this.giftEl.querySelector('[data-gift-text]').textContent = this.t.giftText.replace('[n]', kits);
        this.giftEl.querySelector('[data-gift-bar]').style.width = kits > 0 ? '100%' : '0%';
        this.giftEl.hidden = kits === 0;
      }
    }
  }
  def('b2u-cart-drawer', B2UCartDrawer);

  /* Barra de progreso de scroll horizontal (upsell) */
  class B2UScrollbar extends HTMLElement {
    connectedCallback() {
      const track = document.getElementById(this.dataset.target);
      const bar = this.querySelector('span');
      if (!track || !bar) return;
      const upd = () => {
        const max = track.scrollWidth - track.clientWidth;
        const vis = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(vis * 100, 12) + '%';
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (100 / Math.max(vis, .12) - 100) : 0}%)`;
        this.hidden = max <= 1;
      };
      track.addEventListener('scroll', upd, { passive: true });
      new ResizeObserver(upd).observe(track);
      upd();
    }
  }
  def('b2u-scrollbar', B2UScrollbar);
})();